import * as React from 'react';

/**
 * Pagination State
 */
interface UsePagination {
  /**
   * Represents the current active page
   */
  currentPage: number;
  /**
   * Sets `currentPage` to 1
   */
  reset: () => void;
  /**
   * Increments `currentPage`
   */
  goToNextPage: () => void;
  /**
   * Decrements `currentPage`
   */
  goToPrevPage: () => void;
  /**
   * Go to page
   */
  goToPage: (page: number) => void;
}

export function usePagination(page = 1): UsePagination {
  const [currentPage, setCurrentPage] = React.useState<number>(page);

  const reset = (): void => {
    // Construct URLSearchParams object instance from current URL querystring.
    var queryParams = new URLSearchParams(window.location.search);

    // Set new or modify existing parameter value.
    queryParams.set('page', '1');

    // Replace current querystring with the new one.
    history.replaceState(null, '', '?' + queryParams.toString());

    setCurrentPage(1);
  };

  const goToNextPage = (): void => {
    setCurrentPage((currentP) => {
      // Construct URLSearchParams object instance from current URL querystring.
      var queryParams = new URLSearchParams(window.location.search);

      const updatedPageNumber = currentP + 1;

      // Set new or modify existing parameter value.
      queryParams.set('page', updatedPageNumber.toString());

      // Replace current querystring with the new one.
      history.replaceState(null, '', '?' + queryParams.toString());

      return updatedPageNumber;
    });
  };

  const goToPrevPage = (): void =>
    setCurrentPage((currentP) => {
      // Construct URLSearchParams object instance from current URL querystring.
      var queryParams = new URLSearchParams(window.location.search);

      const updatedPageNumber = currentP - 1;

      // Set new or modify existing parameter value.
      queryParams.set('page', updatedPageNumber.toString());

      // Replace current querystring with the new one.
      history.replaceState(null, '', '?' + queryParams.toString());

      return updatedPageNumber;
    });

  const goToPage = (page: number): void => {
    // Construct URLSearchParams object instance from current URL querystring.
    var queryParams = new URLSearchParams(window.location.search);

    // Set new or modify existing parameter value.
    queryParams.set('page', page.toString());

    // Replace current querystring with the new one.
    history.replaceState(null, '', '?' + queryParams.toString());

    setCurrentPage(page);
  };

  return {
    currentPage,
    reset,
    goToNextPage,
    goToPrevPage,
    goToPage,
  };
}
